import React from 'react'
import PropTypes from 'prop-types'
import {Box, Link, HStack, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const StoreDescription = ({store, showDistance, showName = true, showPhone = true}) => {
    return (
        <Stack
            className="store-description"
            gap="6px"
            color="black"
            fontSize="14px"
            fontWeight="300"
            lineHeight="22px"
            letterSpacing="0.07px"
        >
            {showName && (
                <HStack
                    className="store-description__name-row"
                    gap="10px"
                    alignItems="start"
                    justifyContent="space-between"
                >
                    {store.name && (
                        <Text
                            className="store-description__name"
                            fontSize="16px"
                            fontWeight="400"
                            lineHeight="25px"
                            letterSpacing="0.08px"
                            textTransform="capitalize"
                        >
                            {store.name.toLowerCase()}
                        </Text>
                    )}

                    {store.distance && showDistance && (
                        <Text className="store-description__distance">{store.distance}</Text>
                    )}
                </HStack>
            )}

            {store.calloutMessage && (
                <Box
                    className="store-description__callout"
                    sx={{
                        p: {
                            fontStyle: 'italic'
                        }
                    }}
                    dangerouslySetInnerHTML={{__html: store.calloutMessage}}
                />
            )}
            {showPhone && store.phone && (
                <Box className="store-description__phone-wrapper">
                    <Link className="store-description__phone-link" href={`tel:${store.phone}`}>
                        {store.phone}
                    </Link>
                </Box>
            )}
            {store.address1 && (
                <Text className="store-description__address1" textTransform="capitalize">
                    {store.address1.toLowerCase()}
                </Text>
            )}

            <Box className="store-description__city-state-zip">
                {store.city && (
                    <Text className="store-description__city" as="span" textTransform="capitalize">
                        {store.city.toLowerCase()}
                    </Text>
                )}
                {', '}
                {store.stateCode && (
                    <Text className="store-description__state" as="span">
                        {store.stateCode}
                    </Text>
                )}{' '}
                {store.zip && (
                    <Text className="store-description__zip" as="span">
                        {store.zip}
                    </Text>
                )}
            </Box>
        </Stack>
    )
}

StoreDescription.propTypes = {
    store: PropTypes.shape({
        ID: PropTypes.string,
        name: PropTypes.string,
        distance: PropTypes.string,
        calloutMessage: PropTypes.string,
        phone: PropTypes.string,
        address1: PropTypes.string,
        city: PropTypes.string,
        stateCode: PropTypes.string,
        zip: PropTypes.string
    }),
    showDistance: PropTypes.bool,
    showName: PropTypes.bool,
    showPhone: PropTypes.bool
}

export default StoreDescription
